export default __webpack_public_path__ + "static/evacuation-of-civilians-7bc4dd311b8e188e6142f71588c4f8f7.png";